"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmPayment = void 0;
const tslib_1 = require("tslib");
const v2_1 = require("@wix/bi-logger-cashier-ugc/v2");
const chargeTokenResponseUtils_1 = require("@wix/cashier-core/dist/src/utils/chargeTokenResponseUtils");
const buyerServerConverters_1 = require("@wix/cashier-common/dist/src/utils/transactions/buyerServerConverters");
const amountToLong_1 = require("./amountToLong");
const BiPpWp = 'WP';
/**
 * Function that performs payment 2-factor authentication after server to server charge.
 * It accepts paymentToken in params and returns clientStatus of transaction.
 * In case if transaction requires additional verification (3DS challenge / OTP),
 * user will be redirected to the page with verification form. Redirect is performed in async manner.
 * {@link "../../docs/Payment confirmation.md"}
 */
const confirmPayment = (params) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const charge = (0, chargeTokenResponseUtils_1.parseChargeTokenResponse)(params.chargeResponseToken);
    const clientStatus = (0, buyerServerConverters_1.mapServerToClientStatus)(charge.transactionStatus);
    const clientStatusPublic = (0, buyerServerConverters_1.mapClientStatusToPublic)(clientStatus);
    const result = {
        clientStatus: clientStatusPublic,
    };
    const redirectTo = typeof params.redirectFn === 'function' ? params.redirectFn : window.location.assign.bind(window.location);
    const newApi = (_a = params.newApi) !== null && _a !== void 0 ? _a : false;
    const biLogger = params
        .biLoggerFactory({ endpoint: 'cashier-ugc' })
        .updateDefaults({
        appId: params.meta.appDefId,
        msid: params.meta.msid,
        visitorId: params.meta.visitorId,
        widgetId: params.meta.widgetId,
    })
        .logger();
    if (clientStatus === 'InProcess') {
        // paymentMethod is deprecated (starts with capital letter)
        // paymentMethodId should be used instead, but it's not provided in chargeResponseToken atm
        // @ts-expect-error
        if (charge.paymentMethod === 'PayPal') {
            biLogger.report((0, v2_1.ecwPsd2OvercaptureFlow)({
                transactionStatus: charge.transactionStatus,
                transactionId: charge.chargeId,
                amount: (0, amountToLong_1.amountToLong)(charge.amount),
                currency: charge.currency,
                paymentmethod: charge.paymentMethod,
            }));
        }
        else {
            biLogger.report((0, v2_1.transaction3DsForm)({
                flowType: 'fullPageRedirect',
                isOpened: true,
                transactionId: charge.chargeId,
                paymentProvider: BiPpWp,
            }));
        }
        if (newApi) {
            // onPaymentAuthorized callback should be finished on consumer side to properly
            // close payment method modal.
            // If confirmPayment is used inside onPaymentAuthorized,
            // redirect should happen asynchronously to not block the modal in unfinished state.
            setTimeout(() => {
                redirectTo(charge.redirectUrl);
            });
        }
        else {
            redirectTo(charge.redirectUrl);
            // in case of full-redirect flow, since we already started navigation to another page,
            // we don't want to notify the Client about the payment status (which at this point is InProcess)
            // to avoid them show some ThankYou/Pending page before the redirection takes place,
            // thus returning never-resolved Promise
            // we might extend our public "clientStatus" with "InProcess" and ask Clients to adapt,
            // but this might take a lot of time for them to migrate due to some Clients being in maintenance mode
            return new Promise(() => undefined);
        }
    }
    return result;
});
exports.confirmPayment = confirmPayment;
//# sourceMappingURL=confirmPayment.js.map